const faqs = [
  {
    question: "Does California have its own passport agency?",
    answer:
      "California has three regional passport agencies: the Los Angeles Passport Agency (11000 Wilshire Blvd), the San Francisco Passport Agency (95 Hawthorne St Suite 200), and the San Diego Passport Agency (401 W A Street). All three require appointments and proof of travel within 14 days (or 28 days with a visa application). Most California travelers find that using an approved courier like Fast Passport Center is significantly faster than waiting for an agency appointment.",
  },
  {
    question: "How fast can I get a passport in California?",
    answer:
      "With Fast Passport Center's courier service, California travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks. Given California's high international travel volume, expedited services are especially popular in LA, San Francisco, San Diego, and Silicon Valley.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in California?",
    answer:
      "First-time applicants, minors under 16, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or library). California has hundreds of acceptance facilities across the state. Renewals for adults with a passport issued within the last 15 years can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which California airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major California international airports include Los Angeles (LAX), San Francisco (SFO), San Diego (SAN), Oakland (OAK), Sacramento (SMF), San Jose (SJC), Burbank (BUR), and Long Beach (LGB).",
  },
  {
    question: "Can I renew my passport by mail in California?",
    answer:
      "Yes — if your most recent passport was issued when you were 16 or older, was issued within the last 15 years, is undamaged, and was issued in your current name (or you have legal documentation of a name change), you can renew by mail using Form DS-82. Mail your application to the National Passport Processing Center. For faster service, use an approved expedited courier.",
  },
  {
    question: "Do I need a passport for a Mexico cruise from San Diego or Long Beach?",
    answer:
      "For closed-loop cruises (beginning and ending at the same U.S. port), U.S. citizens can sometimes travel with a government-issued photo ID and birth certificate. However, having a valid passport is strongly recommended — if an emergency requires you to fly home from Mexico, you cannot board a flight without a passport. Many cruise lines now require passports regardless.",
  },
];

export { faqs };

export default function CaliforniaFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            California Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the Golden State.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}